export default "__VITE_ASSET__CH40gMlG__"